module.exports = __webpack_public_path__ + "static/media/intro1-2.947c9524.png";